import {
  Box,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import { useUserControl } from "../../../context/SuperAdmin/UserControlContext";
import SearchIcon from "@mui/icons-material/Search";
import AllUsersPagination from "./UsersPagination";
import PickVersion from "./PickVersion";
import { useEffect, useState } from "react";

const HeadersAllUsers = () => {
  const { search, changeSearch } = useUserControl();
  const [inputValue, setInputValue] = useState(search);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (inputValue !== search) {
        changeSearch(inputValue);
      }
    }, 500);

    return () => clearTimeout(handler);
  }, [inputValue, changeSearch, search]);

  return (
    <Grid
      container
      sx={{ justifyContent: "space-between", alignContent: "center" }}
    >
      {/* Search bar */}
      <Grid item>
        <TextField
          size="small"
          variant="outlined"
          placeholder="Ej: John Doe"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Box sx={{ display: "flex", gap: 4, alignItems: "center" }}>
        <AllUsersPagination />
        <PickVersion />
      </Box>
    </Grid>
  );
};

export default HeadersAllUsers;
